import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';

import Content from './ContentBox';
import ClickOutside from 'app/src/elements/ClickListener';
import { ASSETS_FOR_SELECT } from './queries';

import {
  MarketOption,
  MarketOptionsContainer,
  OptionText
} from './selectElements';

const AssetSelect = ({ selectedSeller, selectedAsset, setAsset }) => {
  const [showOptions, setShowOptions] = useState(false);

  const { data } = useQuery(ASSETS_FOR_SELECT, {
    variables: { sellerId: parseInt(selectedSeller.id) }
  });

  if (!data) { return null; }

  const handleSelect = asset => {
    setAsset(asset);
    setShowOptions(false);
  };

  return (
    <View style={{ flex: 1 }}>
      <Pressable onPress={() => setShowOptions(true)}>
        <Content.ValueBox highlight={!!selectedAsset}>
          <Content.Value color={selectedAsset ? 'white' : null}>
            {selectedAsset?.name || 'Choose an Asset'}
          </Content.Value>
        </Content.ValueBox>
      </Pressable>

      {showOptions && (
        <ClickOutside onClick={() => setShowOptions(false)}>
          <MarketOptionsContainer>
            {data.assets.map(asset => {
              const selected = asset.id === selectedAsset?.id;

              return (
                <MarketOption
                  key={asset.name}
                  onPress={() => handleSelect(asset)}
                  selected={selected}
                >
                  <OptionText selected={selected}>{asset.name}</OptionText>
                </MarketOption>
              );
            })}
          </MarketOptionsContainer>
        </ClickOutside>
      )}
    </View>
  );
};

export default AssetSelect;
